import { addWeeks, endOfWeek, format, parse, startOfWeek, subWeeks } from 'date-fns';

export const getDatesRanges = () => {
  const today = new Date();
  const ranges: { fromDate: string; toDate: string }[] = [];

  for (let i = 1; i < 6; i++) {
    const start = startOfWeek(subWeeks(today, i), { weekStartsOn: 1 });
    const end = endOfWeek(subWeeks(today, i), { weekStartsOn: 1 });

    ranges.push({
      fromDate: format(start, 'yyyy-MM-dd'),
      toDate: format(end, 'yyyy-MM-dd'),
    });
  }
  return ranges;
};

export const getCurrentWeek = () => {
  const today = new Date();
  const start = startOfWeek(today, { weekStartsOn: 1 });
  const end = endOfWeek(today, { weekStartsOn: 1 });
  return `${format(start, 'MM/dd/yyyy')} - ${format(end, 'MM/dd/yyyy')}`;
};

export const getWeekRange = (currentWeek: string, target: WeekTargetType): string => {
  const [startString, endString] = currentWeek.split(' - ');
  const startDateParsed = parse(startString, 'MM/dd/yyyy', new Date());
  const endDateParsed = parse(endString, 'MM/dd/yyyy', new Date());
  const startDate = target === WeekTargetType.NEXT ? addWeeks(startDateParsed, 1) : subWeeks(startDateParsed, 1);
  const endDate = target === WeekTargetType.NEXT ? addWeeks(endDateParsed, 1) : subWeeks(endDateParsed, 1);

  return `${format(startDate, 'MM/dd/yyyy')} - ${format(endDate, 'MM/dd/yyyy')}`;
};

export const isCurrentWeek = (weekString: string): boolean => {
  const now = new Date();
  const currentWeekStart = format(startOfWeek(now, { weekStartsOn: 1 }), 'MM/dd/yyyy');
  const currentWeekEnd = format(endOfWeek(now, { weekStartsOn: 1 }), 'MM/dd/yyyy');
  const currentWeekString = `${currentWeekStart} - ${currentWeekEnd}`;
  return currentWeekString === weekString;
};

export const splitDateByParams = (date: string, target: SplitTargetType) => {
  const [fromDate, toDate] = date.split(' - ');
  if (target === SplitTargetType.FROM) return fromDate;
  if (target === SplitTargetType.TO) return toDate;
};

export const stringByDateString = (stringDate: string) => {
  const regExpToControl = /\d{4}-\d{2}-\d{2}/;
  if (regExpToControl.test(stringDate.slice(0, 10))) {
    const monthAndDay = stringDate.slice(5, 10);
    const rep = monthAndDay.replace(/-/g, '/');
    return rep;
  }
  return '-';
};

export enum WeekTargetType {
  NEXT,
  PREVIOUS,
}
export enum SplitTargetType {
  FROM,
  TO,
}
